import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-customer-home',
  template: '<router-outlet></router-outlet>'
})
export class CustomerHomeComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/home/pages/Dashboard/CustomerDashboardPages/customer-home/customer-home.component.ts